import { useEffect } from "react";
import { useResolvedDocumentBranding } from "hooks/useBranding";

const FAVICON_SELECTOR = "link[rel='icon']";

function upsertFavicon(href) {
  if (!href || typeof document === "undefined") return;

  let link = document.querySelector(FAVICON_SELECTOR);
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }

  if (link.href !== href) link.href = href;
}

export default function BrandingHead() {
  const { title, faviconUrl } = useResolvedDocumentBranding();

  useEffect(() => {
    if (title) document.title = title;
    upsertFavicon(faviconUrl);
  }, [title, faviconUrl]);

  return null;
}
